<ng-template #collaborationsHeader let-data
  ><fa-icon [icon]="faUsers"></fa-icon> {{ relatedNetworksTitle }}</ng-template
>
<ng-template #worksHeader let-data
  ><fa-icon [icon]="faBriefcase"></fa-icon> Related Works ({{
    _person ? _person.relevantWorksCount : 0
  }})</ng-template
>

<aa-person-header
  [profile]="personProfile"
  [units]="personUnits"
></aa-person-header>

<aa-tabs
  dataQaTag="tab-list"
  [tabDefinitions]="tabDefinitions"
  (tabSelect)="changeView($event)"
></aa-tabs>

@if (
  collaborativeNetworkAndActivitiesListCurrentView ===
  CollaborativeNetworkAndActivitiesListViewType.Network
) {
  <app-relevancy-collaborations
    [person]="_person"
    (loading)="setLoading($event)"
  ></app-relevancy-collaborations>
} @else {
  <app-relevancy-activities
    [person]="_person"
    (loading)="setLoading($event)"
  ></app-relevancy-activities>
}

<!-- Needed because dialog element overlaps the existing blocked wrapper on the body  -->
@if (loading) {
  <div class="blocked-wrapper" data-qa="loading-spinner">
    <div class="blocked"></div>
  </div>
}
